module.exports = __webpack_public_path__ + "static/media/agc020.7ae57395.jpg";